// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import './BlogList.css'; // Make sure you style this file

// const Bloghome = () => {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const fetchBlogs = async () => {
//     const res = await axios.get('/api/blogs');
//     setBlogs(res.data);
//   };

//   return (
//     <div>
//       <div className="sapfincon-wrapper">
//   <div className="background-animation">
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//     <div className="floating-circle"></div>
//   </div>
//          {/* <div
//   className="jumbotron jumbotron-fluid page-header position-relative overlay-bottom"
//   style={{ marginBottom: '90px',width: "120vw", position: "relative",left: "-10vw"}}
// >
//   <div
//     className="container text-center py-5 px-0"
//     style={{ marginTop: "-80px" }}
//   >
//     <h1 className="text-white display-1">Blogs</h1>
//     <div className="d-inline-flex text-white mb-5">
//       <p className="m-0 text-uppercase">
//         <a className="text-white" href="">Home</a>
//       </p>
//       <i className="fa fa-angle-double-right pt-1 px-3"></i>
//       <p className="m-0 text-uppercase">Blogs</p>
//     </div>

//     <div className="w-100 mb-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
  
//     </div>
//   </div>
// </div> */}
// <h1 style={{ textAlign: "center", color: "orangered" }}>
//   Products
// </h1>

      
//    <div className="blog-grid">
   
//       {blogs.map(blog => (
//         <div key={blog._id} className="blog-card">
//           <img
//             src={`/uploads/${blog.imagePath}`}
//             alt="blog"
//           />
//           <h3>{blog.title}</h3>
//           <p>{blog.caption}</p>
//           <Link
//             to="/BlogDetail"
//             state={{ id: blog._id }}
//             className="read-more-button"
//           >
//             Read More →
//           </Link>
//         </div>
//       ))}
//     </div>


//     </div></div>
//   );
// };

// export default Bloghome;

// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import './Bloghome.css'; // Optional: If you want to add custom CSS
// const Bloghome = () => {
//   const [blogs, setBlogs] = useState([]);
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const fetchBlogs = async () => {
//     try {
//       const res = await axios.get('/api/blogs');
//       setBlogs(res.data);
//     } catch (err) {
//       console.error("Error fetching blogs", err);
//     }
//   };

//   const scrollLeft = () => sliderRef.current.scrollBy({ left: -350, behavior: 'smooth' });
//   const scrollRight = () => sliderRef.current.scrollBy({ left: 350, behavior: 'smooth' });

//   const styles = {
//     blogSection: {
//       padding: '80px 20px',
      
//       minHeight: '100vh',
//       position: 'relative',
//       fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     },
//     container: {
//       maxWidth: '1400px',
//       margin: '0 auto',
//     },
//     sectionHeader: {
//       textAlign: 'center',
//       marginBottom: '60px',
//     },
//     sectionTitle: {
//       fontSize: '48px',
//       fontWeight: '700',
//       background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//       WebkitBackgroundClip: 'text',
//       WebkitTextFillColor: 'transparent',
//       backgroundClip: 'text',
//       marginBottom: '16px',
//       letterSpacing: '-0.02em',
//     },
//     sectionSubtitle: {
//       fontSize: '18px',
//       color: '#64748b',
//       fontWeight: '400',
//       maxWidth: '600px',
//       margin: '0 auto',
//       lineHeight: '1.6',
//     },
//     sliderWrapper: {
//       position: 'relative',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '20px',
//     },
//     blogSlider: {
//       display: 'flex',
//       overflowX: 'auto',
//       gap: '30px',
//       scrollBehavior: 'smooth',
//       padding: '20px 0',
//       scrollbarWidth: 'none',
//       msOverflowStyle: 'none',
//     },
//     blogCard: {
//       flex: '0 0 320px',
//       background: '#ffffff',
//       borderRadius: '24px',
//       overflow: 'hidden',
//       transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
//       cursor: 'pointer',
//       position: 'relative',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
//     },
//     imageWrapper: {
//       position: 'relative',
//       width: '100%',
//       height: '220px',
//       overflow: 'hidden',
//       background: 'linear-gradient(45deg, #f1f5f9, #e2e8f0)',
//     },
//     image: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
//     },
//     overlay: {
//       position: 'absolute',
//       bottom: 0,
//       left: 0,
//       width: '100%',
//       background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
//       color: '#ffffff',
//       padding: '24px',
//       boxSizing: 'border-box',
//     },
//     overlayTitle: {
//       fontSize: '18px',
//       fontWeight: '600',
//       margin: '0 0 8px',
//       lineHeight: '1.4',
//     },
//     overlayCaption: {
//       fontSize: '14px',
//       margin: 0,
//       opacity: 0.9,
//       lineHeight: '1.5',
//     },
//     cardContent: {
//       padding: '24px',
//       textAlign: 'center',
//     },
//     readMore: {
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: '8px',
//       background: 'orangered',
//       color: '#ffffff',
//       padding: '12px 24px',
//       borderRadius: '50px',
//       textDecoration: 'none',
//       fontWeight: '600',
//       fontSize: '14px',
//       transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//       boxShadow: '0 4px 14px 0 rgba(102, 126, 234, 0.3)',
//     },
//     sliderBtn: {
//       width: '56px',
//       height: '56px',
//       background: '#ffffff',
//       border: '2px solid #e2e8f0',
//       color: '#475569',
//       borderRadius: '50%',
//       cursor: 'pointer',
//       zIndex: 10,
//       transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '18px',
//       fontWeight: 'bold',
//       boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//       backdropFilter: 'blur(10px)',
//     },
//   };

//   return (
//     <div style={styles.blogSection}>
//       <div style={styles.container}>
//         <div style={styles.sectionHeader}>
//           <h1 style={{color:'orangered'}}>Our Products</h1>
//           <p style={styles.sectionSubtitle}>
//             Discover our carefully curated collection of exceptional products designed to elevate your experience
//           </p>
//         </div>

//         <div style={styles.sliderWrapper}>
//           <button
//             style={styles.sliderBtn}
//             onClick={scrollLeft}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
//               e.currentTarget.style.color = '#ffffff';
//               e.currentTarget.style.borderColor = 'transparent';
//               e.currentTarget.style.transform = 'scale(1.1)';
//               e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(102, 126, 234, 0.4)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.background = '#ffffff';
//               e.currentTarget.style.color = '#475569';
//               e.currentTarget.style.borderColor = '#e2e8f0';
//               e.currentTarget.style.transform = 'scale(1)';
//               e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
//             }}
//           >
//             ◀
//           </button>

//           <div
//             style={styles.blogSlider}
//             ref={sliderRef}
//           >
//             {blogs.map(blog => (
//               <div 
//                 key={blog._id} 
//                 style={styles.blogCard}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
//                   e.currentTarget.style.boxShadow = '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.8)';
//                   e.currentTarget.style.borderColor = '#c7d2fe';
//                   const img = e.currentTarget.querySelector('img');
//                   if (img) img.style.transform = 'scale(1.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0) scale(1)';
//                   e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
//                   e.currentTarget.style.borderColor = '#e2e8f0';
//                   const img = e.currentTarget.querySelector('img');
//                   if (img) img.style.transform = 'scale(1)';
//                 }}
//               >
//                 <div style={styles.imageWrapper}>
//                   <img
//                     src={`/uploads/${blog.imagePath}`}
//                     alt={blog.title}
//                     style={styles.image}
//                   />
//                   <div style={styles.overlay}>
//                     <h3 style={styles.overlayTitle}>{blog.title}</h3>
//                     <p style={styles.overlayCaption}>{blog.caption}</p>
//                   </div>
//                 </div>
                
//                 <div style={styles.cardContent}>
//                   <Link
//                     to="/BlogDetail"
//                     state={{ id: blog._id }}
//                     style={styles.readMore}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = 'translateY(-2px)';
//                       e.currentTarget.style.boxShadow = '0 8px 25px 0 rgba(102, 126, 234, 0.4)';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = 'translateY(0)';
//                       e.currentTarget.style.boxShadow = '0 4px 14px 0 rgba(102, 126, 234, 0.3)';
//                     }}
//                   >
//                     Read More
//                     <span style={{ fontSize: '12px' }}>→</span>
//                   </Link>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             style={styles.sliderBtn}
//             onClick={scrollRight}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
//               e.currentTarget.style.color = '#ffffff';
//               e.currentTarget.style.borderColor = 'transparent';
//               e.currentTarget.style.transform = 'scale(1.1)';
//               e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(102, 126, 234, 0.4)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.background = '#ffffff';
//               e.currentTarget.style.color = '#475569';
//               e.currentTarget.style.borderColor = '#e2e8f0';
//               e.currentTarget.style.transform = 'scale(1)';
//               e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
//             }}
//           >
//             ▶
//           </button>
//         </div>
//       </div>

//       <style>{`
//         .blogSlider::-webkit-scrollbar {
//           display: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Bloghome;



import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './Bloghome.css'; // You can rename it later to ProductHome.css if you like

const Selhome = () => {
  const [sells, setSells] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    fetchSells();
  }, []);

  const fetchSells = async () => {
    try {
      const res = await axios.get('/api/Sells'); // ✅ Changed to Sells API
      setSells(res.data);
    } catch (err) {
      console.error("Error fetching products", err);
    }
  };

  const scrollLeft = () => sliderRef.current.scrollBy({ left: -350, behavior: 'smooth' });
  const scrollRight = () => sliderRef.current.scrollBy({ left: 350, behavior: 'smooth' });

  return (
    <div className="blog-section">
      <div className="container">
        <div className="section-header">
          <h1 className="naga">Supply to Us Products</h1>
        </div>

        {/* Slider Section */}
        <div className="slider-wrapper">
          <button className="slider-btn left" onClick={scrollLeft}>◀</button>

          <div className="blog-slider" ref={sliderRef}>
            {sells.map(sell => (
              <div key={sell._id} className="blog-card">
                <div className="image-wrapper">
                  {sell.imagePath && (
                    <img
                      src={`/uploads/${sell.imagePath}`} // ✅ Changed to sells images
                      alt={sell.title}
                      className="blog-image"
                    />
                  )}
                  <div className="overlay">
                    <h3 className="overlay-title">{sell.title}</h3>
                    <p className="overlay-caption">{sell.caption}</p>
                  </div>
                </div>

                <div className="card-content">
                  <Link
                    to="/SellDetail" // ✅ Changed to SellDetail page
                    state={{ id: sell._id }}
                    className="read-more"
                  >
                    Read More <span className="arrow">→</span>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <button className="slider-btn right" onClick={scrollRight}>▶</button>
        </div>

        {/* Products Grid Section */}
        {/* <div className="blog-grid mt-5">
          {sells.map(sell => (
            <div key={sell._id} className="blog-card">
              {sell.imagePath && (
                <img
                  src={`/uploads/${sell.imagePath}`}
                  alt={sell.title}
                  className="blog-image"
                />
              )}
              <h3>{sell.title}</h3>
              <p>{sell.caption}</p>
              <Link
                to="/SellDetail"
                state={{ id: sell._id }}
                className="read-more-button"
              >
                Read More →
              </Link>
            </div>
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default Selhome;
